/**
 * Shared HTML sanitizer for admin-authored article content.
 * Uses sanitize-html (pure JS, no jsdom) so it also works in the worker SSR
 * runtime, where jsdom based sanitizers crash the whole render.
 */
import sanitizeHtml from "sanitize-html";

const ALLOWED_TAGS = [
  "p", "h2", "h3", "h4",
  "ul", "ol", "li",
  "strong", "em", "br", "hr",
  "a", "blockquote", "code",
  "table", "thead", "tbody", "tr", "th", "td",
];

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function sanitizeArticleHtml(html: string): string {
  if (!html) return "";
  try {
    return sanitizeHtml(html, {
      allowedTags: ALLOWED_TAGS,
      allowedAttributes: { a: ["href", "target", "rel"] },
      allowedSchemes: ["http", "https", "mailto"],
      disallowedTagsMode: "discard",
    });
  } catch (error) {
    // Never let a sanitizer failure take down the whole page render.
    console.error("[sanitizeArticleHtml] sanitize failed", error instanceof Error ? error.message : error);
    return escapeHtml(html.replace(/<[^>]*>/g, ""));
  }
}
